<template>
  <div class="container">
    <br>
    <br>
    <footer class="pt-4 my-md-5 pt-md-5 border-top bap-title">
      <div class="row">
        <div class="col-12 col-md">
          <small class="d-block text-muted bap-title"><span class="bap-title">{{ bookTitle }}</span></small>
          <small class="d-block text-muted bap-title"><span class="bap-title">By Maximilien Andile</span></small>
          <small class="d-block text-muted bap-title"><span class="bap-title">Copyright (c) {{ currentYear }}</span></small>

        </div>
        <div class="col-6 col-md">
          <h6>Follow me</h6>
          <ul class="list-unstyled text-small">
            <li>
              <b-link href="https://twitter.com/MaximilienAld" target="_blank" >
                <TwitterIcon></TwitterIcon>
              </b-link>
              <b-link href="https://www.linkedin.com/in/maximilienandile/" target="_blank" class="ml-2">
                <LinkedinIcon></LinkedinIcon>
              </b-link>
            </li>
          </ul>
          <h6>Support the author</h6>
          <form action="https://www.paypal.com/donate" method="post" target="_top">
            <input type="hidden" name="hosted_button_id" value="SJVCKHV9FAY8Y" />
            <input type="image" src="https://www.paypalobjects.com/en_US/FR/i/btn/btn_donateCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
          </form>
        </div>
        <div class="col-6 col-md">
          <h6>Contents</h6>
          <ul class="list-unstyled text-small">
            <li>
              <b-link class="text-muted footer-links" :to="{ name: routeNames.POSTS }">
                Posts
              </b-link>
            </li>
            <li>
              <b-link class="text-muted footer-links" :to="{ name: routeNames.HOME }">
                Book
              </b-link>
            </li>
            <li>
              <b-link class="text-muted footer-links" :to="{ name: routeNames.TUTORIAL,params : {tutorialId: this.tutorialId, slug: 'build-ecommerce-website-golang-vuejs-gin-aws-lambda'}}">
                Video Tutorial
              </b-link>
            </li>
          </ul>
        </div>
        <div class="col-6 col-md">
          <h6>About</h6>
          <ul class="list-unstyled text-small">
            <li>
              <b-link class="text-muted footer-links" :to="{ name: routeNames.THE_AUTHOR }">
                The author
              </b-link>
            </li>
            <li>
              <b-link class="text-muted footer-links" :to="{ name: routeNames.LEGAL }">
                Legal Notice
              </b-link>
            </li>
            <li>
              <b-link class="text-muted footer-links" :to="{ name: routeNames.FEEDBACK }">
                Feedback
              </b-link>
            </li>
            <li>
              <b-link class="text-muted footer-links" :to="{ name: routeNames.BUY }">
                Buy paper or digital copy
              </b-link>
            </li>
            <li>
              <b-link class="text-muted footer-links" :to="{ name: routeNames.TERMS_CONDITIONS }">
                Terms and Conditions
              </b-link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Consts from '@/consts'

import TwitterIcon from "@/components/TwitterIcon";
import LinkedinIcon from "@/components/LinkedinIcon";
export default {
  name: "Footer",
  components: {LinkedinIcon, TwitterIcon},
  data() {
    let currentYear = new Date().getFullYear()  // returns the current year
    return {
      tutorialId: process.env.VUE_APP_MAIN_TUTORIAL_ID,
      bookTitle : Consts.BOOK_TITLE,
      routeNames : Consts.ROUTE_NAMES,
      currentYear: currentYear,
    }
  },
  methods: {}
}
</script>

<style scoped>
.footer-links {
  font-size: 0.9rem;
}

</style>
